import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';

import { patchUser, clearPatchUser } from 'redux/settings/actions';
import { fetchMe } from 'redux/users/actions';

import { Loader, Dimmer, Checkbox } from 'semantic-ui-react';

import UserTitle from 'components/dashboard/appearance-content/UserTitle';
import FixedNotification from 'components/common/FixedNotification';
import CommonPopup from 'components/common/CommonPopup';

import CommonImageDropzone from 'components/common/CommonImageDropzone';
import ProFeaturePlaceholder
  from 'components/common/ProFeaturePlaceholder';
import { getImageUrl } from 'utils/common';

import './CoverImageSelector.css';


class CoverImageSelector extends Component {
  static propTypes = {
    fetchMe: PropTypes.func.isRequired,
    patchUser: PropTypes.func.isRequired,
    clearPatchUser: PropTypes.func.isRequired,
    me: PropTypes.object,
    patchUserSuccess: PropTypes.object,
  };

  static defaultProps = {
    me: null,
    patchUserSuccess: null,
  };

  state = {
    showNotification: false,
    showLoader: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.me.cover !== this.props.me.cover) {
      setTimeout(() => {
        this.setState({ showLoader: false });
      }, 500);
    }
  }

  onImageDrop = droppedImage => {
    if (droppedImage) {
      const form = new FormData();
      form.append('cover', droppedImage.imageBlob, droppedImage.name);
      this.props.patchUser(form);
    }
    this.setState({ showLoader: true });
  };

  onImageRemove = () => {
    const form = new FormData();
    form.append('cover', '');
    this.props.patchUser(form);
    this.setState({ showNotification: true });
  };

  onCheckboxChange = data => {
    const form = new FormData();
    form.append(data.name, data.checked);
    this.props.patchUser(form);
  };

  render() {
    const { me } = this.props;
    const { showNotification, showLoader } = this.state;

    return (
      <Translation>
        {(t) => (
          <div className="cover-image-selector__component">
            {/* Cover Image selector */}
            <div className="cover-image-selector-wrapper">
              {/* Cover Image Wrapper */}
              <div className="cover-image-wrapper">
                <div className="cover-image-content">
                  {!showLoader ?
                    <CommonImageDropzone
                      onDropImage={this.onImageDrop}
                    >
                      <div
                        className="image-container"
                        style={{ backgroundImage: me.cover && `url(${getImageUrl(me, true)})` }}
                      />
                    </CommonImageDropzone>
                    :
                    <Dimmer active>
                      <Loader />
                    </Dimmer>
                  }
                </div>

                {/* Buttons Wrapper */}
                <div className="buttons-wrapper">
                  <CommonImageDropzone
                    onDropImage={this.onImageDrop}
                  >
                    <div className="button upload">{t("Upload Cover")}</div>
                  </CommonImageDropzone>

                  {me &&
                    me.cover &&
                    !me.cover.includes('static/images/defaults') &&
                    <div
                      className="button remove"
                      onClick={this.onImageRemove}
                      role="button"
                      tabIndex={-1}
                    >
                      <div className="icon" />
                      <div className="text">{t("Remove")}</div>
                    </div>
                  }
                </div>
              </div>

              {/* Title Wrapper */}
              <div className="title-wrapper">
                <div className="user-title">
                  <UserTitle />
                </div>
                <div className="subtext">
                  {t("Profile Title")}
                  <CommonPopup
                    infoIcon
                    type="info"
                  >
                    {t("Title will be shown under cover image")}
                  </CommonPopup>
                </div>
              </div>

            </div>

            <div className="cover-image-selector-controls">
              <div className="cover-image-selector-controls-wrapper">

                <div className="control-item cover-image">
                  <p>{t("Hide Cover")}</p>
                  <ProFeaturePlaceholder
                    proLabel
                    locked={me && me.subscription && !me.subscription.ff_cover}
                    placeholderContent={
                      <div>
                        {t("You can hide cover image on the PRO plan.")}
                      </div>
                    }
                    className="cover-image-selector-controls-pro-placeholder"
                  >
                    <div className="switcher-wrapper">
                      <span>{t("OFF")}</span>
                      <Checkbox
                        toggle
                        checked={me.avatar_is_hidden || false}
                        name="avatar_is_hidden"
                        onChange={(_e, data) => { this.onCheckboxChange(data); }}
                        disabled={me && me.subscription && !me.subscription.ff_cover}
                      />
                      <span>{t("ON")}</span>
                    </div>
                  </ProFeaturePlaceholder>
                </div>

                <div className="control-item profile-title">
                  <p>{t("Hide Title")}</p>
                  <ProFeaturePlaceholder
                    proLabel
                    locked={me && me.subscription && !me.subscription.ff_cover}
                    placeholderContent={
                      <div>
                        {t("You can hide title on the PRO plan.")}
                      </div>
                    }
                    className="cover-image-selector-controls-pro-placeholder"
                  >
                    <div className="switcher-wrapper">
                      <span>{t("OFF")}</span>
                      <Checkbox
                        toggle
                        checked={me.username_is_hidden || false}
                        name="username_is_hidden"
                        onChange={(_e, data) => { this.onCheckboxChange(data); }}
                        disabled={me && me.subscription && !me.subscription.ff_cover}
                      />
                      <span>{t("ON")}</span>
                    </div>
                  </ProFeaturePlaceholder>
                </div>
              </div>
            </div>

            {showNotification &&
              <FixedNotification
                onFadeComplete={() => {
                  this.setState({ showNotification: false });
                }}
              >
                {t("Cover Image has been removed!")}
              </FixedNotification>
            }
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    patchUserSuccess: state.settingsReducer.patchUserSuccess,
  }
);

export default connect(
  mapStateToProps,
  {
    patchUser,
    clearPatchUser,
    fetchMe,
  },
)(CoverImageSelector);
